import moment from 'moment'
import { primary_color } from '../../../../Helper/uiHelper'

const parseJson = (value) => {
  if (!value) return {}
  if (typeof value === 'object') return value
  try {
    return JSON.parse(value)
  } catch (e) {
    return {}
  }
}

const FIELDS = [
  { key: 'lock_id', label: 'Lock ID' },
  { key: 'lock_code', label: 'Lock Code' },
  { key: 'sequence', label: 'Sequence' },
]

const display = (value) => {
  if (value === null || value === undefined || value === '') return '--'
  return value
}

const actionLabel = (type) => {
  if (type === 'year_codes_import') return 'imported locker codes'
  if (type === 'new_code') return 'assigned a new lock code'
  return 'updated locker codes'
}

const ShowDifference = ({ data, original_data, updated_data, onExpand }) => {
  const changedFields = FIELDS.filter((field) => {
    const next = display(updated_data?.[field.key])
    const prev = display(original_data?.[field.key])
    return String(next) !== String(prev)
  })
  const fileUrl = updated_data?.import_file_url || original_data?.import_file_url
  const fileName = updated_data?.import_file_name || original_data?.import_file_name || 'Uploaded template'

  return (
    <div>
      <div className='permission-table'>
        <div className='mb-2 cursor-pointer' onClick={() => onExpand()}>
          <i className='fa-sharp fa-solid fa-arrow-left m-3'></i>
          Go Back
        </div>
        <div className='permission-header' style={{ color: primary_color }}>
          <div className='d-flex align-items-center'>
            <div style={{ flex: 1 }}>
              <span className='font-weight-bold'>{data?.updated_by}</span>
              {` has ${actionLabel(data?.type)}`}
            </div>
            {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
          </div>
        </div>
        <div className='px-5 py-4'>
          {fileUrl ? (
            <div className='mb-3'>
              <div className='font-weight-bold mb-1' style={{ color: primary_color }}>
                Uploaded template
              </div>
              <a href={fileUrl} target='_blank' rel='noreferrer'>
                {fileName}
              </a>
            </div>
          ) : null}
          <div className='d-flex mb-2 font-weight-bold body2' style={{ color: primary_color }}>
            <div style={{ width: '34%' }}>Field</div>
            <div style={{ width: '33%' }}>New value</div>
            <div style={{ width: '33%' }}>Previous value</div>
          </div>
          {changedFields.length === 0 ? (
            <div className='subtitle1 text-muted'>No field differences recorded.</div>
          ) : (
            changedFields.map((field) => {
              const next = display(updated_data?.[field.key])
              const prev = display(original_data?.[field.key])
              return (
                <div className='d-flex mb-2 align-items-center' key={field.key} style={{ width: '100%' }}>
                  <div className='font-weight-bold' style={{ width: '34%' }}>
                    {field.label}
                  </div>
                  <div style={{ width: '33%' }}>{next}</div>
                  <div style={{ width: '33%' }} className='p-2 bg-danger text-light'>
                    {prev}
                  </div>
                </div>
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}

const YearCodesChangeLog = ({ data, onExpand, expandedId }) => {
  const updated_data = parseJson(data?.updated_data)
  const original_data = parseJson(data?.original_data)
  const lockerNumber = updated_data?.locker_number || original_data?.locker_number

  if (expandedId) {
    return <ShowDifference data={data} original_data={original_data} updated_data={updated_data} onExpand={onExpand} />
  }

  return (
    <div className='d-flex align-items-center p-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
      <div>
        <i
          className='fa-solid fa-arrow-up-right-from-square mr-2 cursor-pointer'
          style={{ color: primary_color }}
          onClick={() => onExpand(data?.id)}></i>
      </div>
      <div style={{ flex: 1 }}>
        <span className='font-weight-bold'>{data?.updated_by}</span>
        {` has ${actionLabel(data?.type)}${lockerNumber ? ` for locker ${lockerNumber}` : ''}.`}
      </div>
      {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
    </div>
  )
}

export default YearCodesChangeLog
